import React, { memo } from 'react'
import { util } from '../../../util'
import PropTypes from 'prop-types'

const Icon = ({
    className,
    color,
    disabled = false,
    display,
    margin,
    onClick,
    pointer,
    renderIcon,
    size,
    readOnly,
    ...rest
}) => {
    const iconClass = util.joinClasses(
        'svg-icon',
        size,
        pointer && 'pointer',
        display,
        margin,
        className,
        color,
        readOnly && 'read-only'
    )
    return (
        <div className={iconClass} onClick={!disabled ? onClick : undefined} {...rest}>
            {/* renderIcon will return MaterialUI SVG component */}
            {renderIcon && renderIcon()}
        </div>
    )
}

Icon.propTypes = {
    className: PropTypes.string,
    color: PropTypes.oneOf([
        'gray',
        'disable',
        'danger',
        'color-check',
        'success',
        'warning',
        'initial',
        'warning-yellow',
        'info',
    ]),
    disabled: PropTypes.bool,
    display: PropTypes.oneOf(['inline', 'block', 'inline-block']),
    margin: PropTypes.string,
    onClick: PropTypes.oneOfType([PropTypes.func]),
    pointer: PropTypes.bool,
    renderIcon: PropTypes.func.isRequired,
    size: PropTypes.oneOf(['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
}

export default memo(Icon)
